import { Component, OnInit, ɵclearResolutionOfComponentResourcesQueue, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ContratoDataService } from 'src/app/core/services/contrato-crud.service';
import { Contrato } from 'src/app/model/contrato/contrato';

@Component({
    selector: 'app-contrato-edit',
    templateUrl: './contrato-edit.component.html',
    styleUrls: ['./contrato-edit.component.css'],
    standalone: false
})
export class ContratoEditComponent implements OnInit, OnDestroy {

  public contratoId: number;
  public contrato: Contrato;
  public running: boolean;

  private sub: any;

  constructor(private router: Router, private route: ActivatedRoute, private dataService: ContratoDataService) {
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.contratoId = +params['contratoId'];

      if (isNaN(this.contratoId)) { this.contratoId = -1; }

      this.dataService
        .get(this.contratoId)
        .subscribe(data => {
          this.contrato = data;
        });
    });
  }

  ngOnDestroy(): void {
    if (this.sub) { this.sub.unsubscribe(); }
  }

  public save = (): void => {
  }

}
